import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../../assets/images/handle/cmm.png';
import _imports_1 from '../../assets/images/handle/jb.png';
import _imports_2 from '../../assets/images/handle/sc.png';
const _hoisted_1 = { class: "yc-handle" };
const _hoisted_2 = {
    key: 1,
    class: "clickable"
};
const _hoisted_3 = { class: "dialog-footer" };
import { ref, onMounted, onBeforeUnmount, reactive } from 'vue';
import { ElMessage, ElInput } from 'element-plus';
import feedback from '../../utils/feedback';
import request from '../../api/request';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import chat from '../../utils/AI/chat';
export default /*@__PURE__*/ _defineComponent({
    __name: 'yc-handle',
    props: {
        datas: {},
        showRename: { type: Boolean, default: true },
        showDelete: { type: Boolean, default: true },
        showJunbao: { type: Boolean, default: false }
    },
    emits: ['init', 'close', 'update'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const store = useStore();
        const router = useRouter();
        const emits = __emit;
        const props = __props;
        onMounted(() => {
            document.addEventListener('mousedown', handleClickOutside);
            const element = document.querySelector('.yc_scrollview');
            element === null || element === void 0 ? void 0 : element.addEventListener('scroll', handleScroll, { passive: true });
        });
        onBeforeUnmount(() => {
            document.removeEventListener('mousedown', handleClickOutside);
            const element = document.querySelector('.yc_scrollview');
            element === null || element === void 0 ? void 0 : element.removeEventListener('scroll', handleScroll);
        });
        const visible = ref(false);
        const popoverRef = ref();
        const open = () => {
            visible.value = true;
        };
        const close = () => {
            visible.value = false;
        };
        const handleClickOutside = event => {
            var _a;
            if (popoverRef.value && !((_a = popoverRef.value) === null || _a === void 0 ? void 0 : _a.$el.contains(event.target))) {
                visible.value = false; // 如果点击的元素不在 el-popover 内部，隐藏它
                emits('close');
            }
        };
        const handleScroll = () => {
            close();
        };
        const editName = reactive({
            show: false,
            inputValue: '',
            errMsg: '',
            nowData: {},
            isFocus: false
        });
        const handleEditInput = (e) => {
            editName.errMsg = e ? '' : '请输入对话名称';
        };
        const handleEditNameClose = () => {
            editName.show = false;
        };
        const handleEditNameSubmit = () => {
            if (!editName.inputValue)
                return;
            editName.show = false;
            let value = editName.inputValue;
            handleHistory('rename', editName.nowData, value);
        };
        const handleInputFocus = (isFocus) => {
            let dom = document.querySelector('.editNameDialogClass');
            console.log('isFocus', dom);
            editName.isFocus = isFocus;
            if (!dom)
                return;
            if (isFocus) {
                dom.style.marginTop = '5vh !important';
            }
            else {
                dom.style.marginTop = '40vh !important';
            }
        };
        const handleChange = (handleName, item) => {
            let nowItem = (item === null || item === void 0 ? void 0 : item.data) || item || {};
            switch (handleName) {
                case 'del':
                    feedback
                        .confirm('是否删除该条消息')
                        .then(res => {
                        if (res === 'confirm') {
                            handleHistory('delete', item);
                        }
                    })
                        .catch(err => { });
                    break;
                case 'rename':
                    editName.show = true;
                    editName.nowData = item;
                    editName.inputValue = nowItem.title;
                    break;
            }
        };
        // 操作历史内容
        const handleHistory = async (key, item = {}, value = '') => {
            let nowItem = (item === null || item === void 0 ? void 0 : item.data) || item || {};
            if (nowItem.modelName == 'ppt' || (item === null || item === void 0 ? void 0 : item.categoryCode) == 'PPT') {
                try {
                    key === 'delete' ? await deletePPT(nowItem.id) : await updatePPT(nowItem.id, value);
                }
                catch (error) {
                }
            }
            else if (nowItem.modelName == 'translation' || nowItem.modelName == 'meeting' || (item === null || item === void 0 ? void 0 : item.categoryCode) == 'MEETING' || (item === null || item === void 0 ? void 0 : item.categoryCode) == 'TRANSLATION') {
                try {
                    key === 'delete' ? await deleteHistory(nowItem, item) : await updateHistory(nowItem, value, item);
                }
                catch (error) {
                }
            }
            else if (nowItem.modelName == 'drawing' || (item === null || item === void 0 ? void 0 : item.categoryCode) == 'IMAGE' || (item === null || item === void 0 ? void 0 : item.categoryCode) == 'IMAGE_IMG2IMG') {
                try {
                    key === 'delete' ? await deleteDrawChatById(nowItem.id) : await updateDrawChat(nowItem.id, value);
                }
                catch (error) {
                }
            }
            else if (nowItem.modelName == 'music' || (item === null || item === void 0 ? void 0 : item.categoryCode) == 'MUSIC') {
                try {
                    key === 'delete' ? await deleteMusicChatById(nowItem.id) : await updateMusicChat(nowItem.id, value);
                }
                catch (error) {
                }
            }
            else if (nowItem.modelData == 'znt' || (item === null || item === void 0 ? void 0 : item.categoryCode) == 'ZNT') {
                try {
                    key === 'delete' && await deleteZntChatById(nowItem.id);
                }
                catch (error) {
                }
            }
            else {
                try {
                    key === 'delete' ? await deleteChatById(nowItem.id) : await updateChat(nowItem.id, nowItem.modelId, value);
                }
                catch (error) {
                }
            }
            store.commit('setHistroyList');
            if (item === null || item === void 0 ? void 0 : item.categoryCode) {
                let jump = '';
                if (key === 'rename') {
                    let newData = JSON.parse(JSON.stringify(nowItem));
                    newData.title = value;
                    jump = feedback.getRouteJump(item === null || item === void 0 ? void 0 : item.categoryCode, newData);
                }
                else {
                    jump = '/';
                }
                if (jump) {
                    router.replace(jump);
                }
            }
        };
        // 更新对话
        const updateChat = async (id, modelId, value) => {
            return new Promise((resolve, reject) => {
                chat
                    .updateChat(id, modelId, value)
                    .then((res) => {
                    emits('update');
                    resolve(res);
                })
                    .catch(() => { reject(); });
            });
        };
        // 更新ppt
        const updatePPT = (id, value) => {
            return new Promise((resolve, reject) => {
                request.post(`/app-api/lt/ai/ppt/updatePptSession`, { id: id, title: value }).then((res) => {
                    if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                        feedback.msgSuccess((res === null || res === void 0 ? void 0 : res.msg) || '操作成功');
                        close();
                        emits('init');
                        emits('update');
                        resolve(res);
                    }
                })
                    .catch(() => { reject(); });
            });
        };
        // 更新绘画对话
        const updateDrawChat = (id, value) => {
            return new Promise((resolve, reject) => {
                chat
                    .updateDrawChat(id, value)
                    .then((res) => {
                    store.commit('setDrawHistroyList');
                    emits('update');
                    resolve(res);
                })
                    .catch(() => { reject(); });
            });
        };
        // 更新音乐对话
        const updateMusicChat = (id, value) => {
            return new Promise((resolve, reject) => {
                chat
                    .updateMusicChat(id, value)
                    .then((res) => {
                    store.commit('setDrawHistroyList');
                    emits('update');
                    resolve(res);
                })
                    .catch(() => { reject(); });
            });
        };
        // 删除智能体
        const deleteZntChatById = (id) => {
            return new Promise((resolve, reject) => {
                request.delete(`/app-api/lt/ai/chat/conversation/delete-my?id=${id}`, {}).then((res) => {
                    if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                        feedback.msgSuccess((res === null || res === void 0 ? void 0 : res.msg) || '操作成功');
                        close();
                        emits('init');
                        emits('update');
                        store.dispatch('intelligence/getHistoryList');
                        resolve(res);
                    }
                })
                    .catch(() => { reject(); });
            });
        };
        // 删除对话
        const deleteChatById = (id) => {
            return new Promise((resolve, reject) => {
                request.delete(`/app-api/lt/ai/chat/conversation/delete-my?id=${id}`, {}).then((res) => {
                    if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                        feedback.msgSuccess((res === null || res === void 0 ? void 0 : res.msg) || '操作成功');
                        close();
                        emits('init');
                        emits('update');
                        resolve(res);
                    }
                })
                    .catch(() => { reject(); });
            });
        };
        // 删除绘画对话
        const deleteDrawChatById = (id) => {
            return new Promise((resolve, reject) => {
                request.post(`/app-api/lt/ai/image/deleteAllSession`, { id: id }).then((res) => {
                    if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                        feedback.msgSuccess((res === null || res === void 0 ? void 0 : res.msg) || '操作成功');
                        close();
                        emits('init');
                        emits('update');
                        store.commit('setDrawHistroyList');
                        resolve(res);
                    }
                    else {
                        ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                        reject();
                    }
                })
                    .catch(() => { reject(); });
            });
        };
        // 删除音乐对话
        const deleteMusicChatById = (id) => {
            return new Promise((resolve, reject) => {
                request.delete(`/app-api/lt/ai/volc/music/delete?id=${id}`, {}).then((res) => {
                    if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                        feedback.msgSuccess((res === null || res === void 0 ? void 0 : res.msg) || '操作成功');
                        close();
                        emits('init');
                        emits('update');
                        store.commit('setDrawHistroyList');
                        resolve(res);
                    }
                    else {
                        ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                        reject();
                    }
                })
                    .catch(() => { reject(); });
            });
        };
        // 删除会议和同声历史
        const deleteHistory = (item, nowItem) => {
            return new Promise((resolve, reject) => {
                let url = item.modelName == 'translation' || (nowItem === null || nowItem === void 0 ? void 0 : nowItem.categoryCode) == 'TRANSLATION' ? 'translation/deleteById' : 'meeting/deleteById';
                request.post(`/app-api/lt/ai/${url}`, {
                    id: item === null || item === void 0 ? void 0 : item.id,
                }).then(async (res) => {
                    if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                        feedback.msgSuccess((res === null || res === void 0 ? void 0 : res.msg) || '操作成功');
                        close();
                        emits('update');
                        resolve(res);
                    }
                    else {
                        ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                        reject();
                    }
                })
                    .catch(() => { reject(); });
            });
        };
        // 删除ppt
        const deletePPT = (id) => {
            return new Promise((resolve, reject) => {
                request.post(`/app-api/lt/ai/ppt/delPptSession`, { id: id }).then((res) => {
                    if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                        feedback.msgSuccess((res === null || res === void 0 ? void 0 : res.msg) || '操作成功');
                        close();
                        emits('update');
                        resolve(res);
                    }
                    else {
                        ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                        reject();
                    }
                })
                    .catch(() => { reject(); });
            });
        };
        // 更新
        const updateHistory = (item, value, nowItem) => {
            return new Promise((resolve, reject) => {
                let url = item.modelName === 'translation' || (nowItem === null || nowItem === void 0 ? void 0 : nowItem.categoryCode) == 'TRANSLATION' ? 'translation/updateById' : 'meeting/updateMeetingRecord';
                request.post(`/app-api/lt/ai/${url}`, {
                    id: item === null || item === void 0 ? void 0 : item.id,
                    name: value
                }).then(async (res) => {
                    if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                        feedback.msgSuccess((res === null || res === void 0 ? void 0 : res.msg) || '操作成功');
                        close();
                        emits('update');
                        resolve(res);
                    }
                    else {
                        ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                        reject();
                    }
                })
                    .catch(() => { reject(); });
            });
        };
        __expose({
            open,
            close
        });
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_popover, {
                    ref_key: "popoverRef",
                    ref: popoverRef,
                    "popper-class": "yhPopover",
                    placement: "bottom-end",
                    title: "",
                    width: 160,
                    visible: visible.value,
                    trigger: "click",
                    content: ""
                }, {
                    reference: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "yh_wrap",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            (_ctx.showRename)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: "clickable",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (handleChange('rename', _ctx.datas)))
                                }, _cache[7] || (_cache[7] = [
                                    _createElementVNode("img", { src: _imports_0 }, null, -1),
                                    _createElementVNode("span", null, "重命名", -1)
                                ])))
                                : _createCommentVNode("", true),
                            (_ctx.showJunbao)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _cache[8] || (_cache[8] = [
                                    _createElementVNode("img", { src: _imports_1 }, null, -1),
                                    _createElementVNode("span", null, "举报", -1)
                                ])))
                                : _createCommentVNode("", true),
                            (_ctx.showDelete)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 2,
                                    class: "clickable",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (handleChange('del', _ctx.datas)))
                                }, _cache[9] || (_cache[9] = [
                                    _createElementVNode("img", { src: _imports_2 }, null, -1),
                                    _createElementVNode("span", { class: "d_color" }, "删除", -1)
                                ])))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 3
                }, 8, ["visible"]),
                _createVNode(_component_el_dialog, {
                    class: "editNameDialogClass",
                    modelValue: editName.show,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((editName.show) = $event)),
                    title: "",
                    top: (_unref(store).state.isPad && editName.isFocus) ? '5vh' : '40vh',
                    width: "420",
                    "append-to-body": "",
                    "before-close": handleEditNameClose
                }, {
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_el_button, { onClick: handleEditNameClose }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                    _createTextVNode("取消")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_el_button, {
                                type: "primary",
                                disabled: !editName.inputValue,
                                onClick: handleEditNameSubmit
                            }, {
                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                    _createTextVNode(" 确定 ")
                                ])),
                                _: 1
                            }, 8, ["disabled"])
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", null, [
                            _cache[10] || (_cache[10] = _createElementVNode("p", { style: { "margin-bottom": "10px", "font-size": "14px" } }, "编辑对话名称", -1)),
                            _createVNode(_unref(ElInput), {
                                modelValue: editName.inputValue,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((editName.inputValue) = $event)),
                                maxlength: 50,
                                onFocus: _cache[4] || (_cache[4] = ($event) => (handleInputFocus(true))),
                                onBlur: _cache[5] || (_cache[5] = ($event) => (handleInputFocus(false))),
                                onInput: handleEditInput
                            }, null, 8, ["modelValue"])
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue", "top"])
            ]));
        };
    }
});
